import {Period} from "@/modules/periods";

export async function loadConfigByPeriod(period) {
    const periodObject = Period.ofString(period)
    if(Period.ofString('2024_H2_Q3').compare(periodObject) <= 0){
        return JSON.parse(JSON.stringify(config_v2))
    }
    else if (Period.ofString('2023_H2_Q4').compare(periodObject) === 0) {
        return JSON.parse(JSON.stringify(configv1_1))
    } else {
        return JSON.parse(JSON.stringify(configv1_0))
    }
}

/**
 *
 * @param config: Object - конфигурация
 * @param netType: string - CENTRALIZED или DECENTRALIZED
 * @param cznType: string - manager_czn, territorial_czn
 * @return {Promise<void>}
 */
export function filterConfig(config, netType, cznType, cznLevel){
    /*
        * В децентрализованных регионах все пользователи - территориальные ЦЗН, должны отображаться все вопросы
        * В централизованных регионах для управляющих ЦЗН должны отображаться только те вопросы, у которых параметр
        * "onlyManagerCzn" = true,
        * для территориальных ЦЗН должны отображаться только те вопросы, у которых параметр "onlyManagerCzn" = false
        *
        * Дополнительно: если указан cznLevel (может быть 1, 2, 3), отфильтровываются подгруппы по полю group.onlyCznType
        * */

    if(cznLevel) {
        filterCznLevel(config, cznLevel)
    }

    if(netType === 'DECENTRALIZED') {
        return config
    }
    if(netType !== 'CENTRALIZED'){
        throw new Error("Incorrect netType value: " + netType)
    }
    config = JSON.parse(JSON.stringify(config))
    if (cznType === "manager_czn") {
        return filterConfigOnlyManagerCzn(config, true)
    } else if (cznType === "territorial_czn") {
        return filterConfigOnlyManagerCzn(config, false)
    } else {
        throw new Error("Incorrect czn type: " + cznType)
    }
}


function filterCznLevel(config, cznLevel){
    if(config.groups != null){
        for(let i = 0; i < config.groups.length; i++){
            let group = config.groups[i]
            if(group.onlyCznType && group.onlyCznType !== cznLevel) {
                config.groups.splice(i, 1)
                i--
            } else {
                filterCznLevel(group, cznLevel)
            }
        }
    }
}

function filterConfigOnlyManagerCzn(config, onlyManager){
    if(config.groups != null){
        for(let i = 0; i < config.groups.length; i++){
            let group = config.groups[i]
            filterConfigOnlyManagerCzn(group, onlyManager)
            if((group.groups == null || group.groups.length === 0) &&
                (group.questions == null || group.questions.length === 0)){
                config.groups.splice(i, 1)
                i--
            }
        }
    }
    if(config.questions != null){
        config.questions = config.questions.filter(e=>e.onlyManagerCzn === onlyManager)
    }
    return config
}

const configv1_0 = {
    "id": 945966,
    "configParams": {
        "indexGroups": [
            {
                "id": 100,
                "title": "Показатели дружелюбия и партнерства",
                "indices": [
                    {
                        "id": 100,
                        "title": "Открытость руководства",
                        "parameters": [
                            {
                                "id": 100,
                                "title": "Проведение дней, когда руководство «меняется» рабочими местами с сотрудниками приема",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup1_index1_param1"
                            },
                            {
                                "id": 200,
                                "title": "Наличие открытых приемных дней / часов для граждан",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup1_index1_param2"
                            },
                            {
                                "id": 300,
                                "title": "Проведение публичных мероприятий руководства ЦЗН с гражданами",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup1_index1_param3"
                            },
                            {
                                "id": 400,
                                "title": "Публично доступная электронная почта с возможностью обратиться напрямую к руководителю",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup1_index1_param4"
                            },
                            {
                                "id": 500,
                                "title": "Публично доступный номер мобильного / стационарного телефона руководства",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup1_index1_param5"
                            }
                        ],
                        "questionType": "COMMENT",
                        "type": "CHECKLIST"
                    }
                ]
            },
            {
                "id": 200,
                "title": "Показатели полезности обращения в СЗН",
                "indices": [
                    {
                        "id": 100,
                        "title": "Динамика роста базы вакансий",
                        "parameters": [
                            {
                                "id": 100,
                                "title": "Количество вакансий за отчетный период",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup2_index1_param1_current"
                            },
                            {
                                "id": 100,
                                "title": "Количество вакансий за отчетный период",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup2_index1_param1_previous"
                            }
                        ],
                        "questionType": "DYNAMIC",
                        "type": "CHECKLIST"
                    },
                    {
                        "id": 200,
                        "title": "Проведение мероприятий, стимулирующих рост числа соискателей",
                        "parameters": [
                            {
                                "id": 100,
                                "title": "Ярмарка вакансий",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup2_index2_param1"
                            },
                            {
                                "id": 200,
                                "title": "Подача объявлений о ЦЗН в СМИ",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup2_index2_param2"
                            },
                            {
                                "id": 300,
                                "title": "Акции в социальных сетях",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup2_index2_param3"
                            },
                            {
                                "id": 400,
                                "title": "Дни общения с руководством",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup2_index2_param4"
                            },
                            {
                                "id": 500,
                                "title": "Открытый отбор на вакансии конкретного востребованного работодателя",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup2_index2_param5"
                            },
                            {
                                "id": 600,
                                "title": "Деловые игры",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup2_index2_param6"
                            },
                            {
                                "id": 700,
                                "title": "Бизнес консультации по открытию собственного дела",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup2_index2_param7"
                            },
                            {
                                "id": 800,
                                "title": "День открытых дверей в СЗН с презентацией предоставляемых услуг и сервисов",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup2_index2_param8"
                            },
                            {
                                "id": 900,
                                "title": "Экскурсии на предприятия региона",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup2_index2_param9"
                            },
                            {
                                "id": 1000,
                                "title": "И прочие мероприятия",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup2_index2_param10"
                            }
                        ],
                        "questionType": "COMMENT",
                        "type": "CHECKLIST"
                    }
                ]
            },
            {
                "id": 300,
                "title": "Показатели, характеризующие минимизацию усилий клиента",
                "indices": [
                    {
                        "id": 100,
                        "title": "Доступность и понятность информации о работе, услугах и сервисах СЗН в офисе ЦЗН",
                        "parameters": [
                            {
                                "id": 100,
                                "title": "Доступ к информационным стендам/стойкам беспрепятственный (прочесть объявления можно с близкого расстояния, стенды интуитивно легко найти / в ЦЗН есть навигация к инфостендам), в том числе для граждан с инвалидностью",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup3_index1_param1"
                            },
                            {
                                "id": 200,
                                "title": "Информация на стендах актуальна на момент оценки по показателю (проверка на предмет актуальности осуществляется не менее чем 1 раз в 3 месяца)\nПоследняя дата проверки актуальности и обновления информации - указывается дата в АИС",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup3_index1_param2"
                            },
                            {
                                "id": 300,
                                "title": "Соблюдение единого оформления стендов в корпоративном стиле (предпочтительно в соответствии с брендбуком «Работа России») в каждом документе на стенде (шрифты, цвета, фирменные элементы и пр.).",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup3_index1_param3"
                            },
                            {
                                "id": 400,
                                "title": "Информация на инфостендах удобно сгруппирована и структурирована по тематическим разделам (информация различной тематики размещена в различных информационных полях (например, объявления о работе ЦЗН и реклама находятся в разных секциях)), есть заголовки",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup3_index1_param4"
                            },
                            {
                                "id": 500,
                                "title": "Информационные тексты стенда проанализированы на сайте https://glvrd.ru",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup3_index1_param5"
                            }
                        ],
                        "questionType": "COMMENT",
                        "type": "CHECKLIST"
                    },
                    {
                        "id": 200,
                        "title": "Доступность и понятность информации о работе, услугах и сервисах СЗН на региональном сайте",
                        "parameters": [
                            {
                                "id": 100,
                                "title": "Сайт СЗН легко найти в популярных поисковиках (Яндекс, Google) (сайт находится в 3 первых позициях поисковой выдачи при введении запросов «ЦЗН региона», «центр занятости региона», «служба занятости региона»)",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index2_param1"
                            },
                            {
                                "id": 200,
                                "title": "На сайте имеется минимально необходимая информация о СЗН и ЦЗН, в т.ч. перечень и описание государственных услуг и сервисов в сфере занятости, режимы работы отделений и адреса, контактные данные СЗН и ЦЗН, ссылка на сайт «Работа в России», ссылка на сайт ОИВ, курирующих деятельность государственной службы занятости в  субъекте РФ",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index2_param2"
                            },
                            {
                                "id": 300,
                                "title": "Пользователи сайта могут найти минимально необходимую информацию интуитивно и быстро, в т.ч. с помощью навигации",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index2_param3"
                            },
                            {
                                "id": 400,
                                "title": "Сайт адаптирован для граждан с инвалидностью",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index2_param4"
                            },
                            {
                                "id": 500,
                                "title": "Информационные тексты сайта проанализированы на сайте https://glvrd.ru",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index2_param5"
                            }
                        ],
                        "questionType": "COMMENT",
                        "type": "CHECKLIST"
                    },
                    {
                        "id": 300,
                        "title": "Доступность и понятность информации о работе, услугах и сервисах СЗН в социальных сетях",
                        "parameters": [
                            {
                                "id": 100,
                                "title": "Аккаунты ЦЗН в социальных сетях открыты, не требуют подачу заявок и одобрения со стороны администраторов",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index3_param1"
                            },
                            {
                                "id": 200,
                                "title": "Комментарии к публикациям открыты/есть возможность написать сообществу, при это ЦЗН регулярно и своевременно отвечает на комментарии граждан",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index3_param2"
                            },
                            {
                                "id": 300,
                                "title": "Контент, в т.ч. картинки к постам, оформлен в фирменном стиле «Работа в России», визуально считывается",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index3_param3"
                            },
                            {
                                "id": 400,
                                "title": "В неделю размещается не менее 3 постов в одной из социальных сетей (указать, в какой)",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index3_param4"
                            },
                            {
                                "id": 500,
                                "title": "Информационные тексты аккаунта социальной сети проанализированы на сайте https://glvrd.ru",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index3_param5"
                            }
                        ],
                        "questionType": "COMMENT",
                        "type": "CHECKLIST"
                    },
                    {
                        "id": 400,
                        "title": "Доступность и понятность информации о работе, услугах и сервисах СЗН в контакт-центре",
                        "parameters": [
                            {
                                "id": 100,
                                "title": "Информация о контакт-центре доступна во всех каналах взаимодействия с гражданами (в офисе ЦЗН, на сайте, в социальных сетях), в том числе информация адаптирована для граждан с инвалидностью",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index4_param1"
                            },
                            {
                                "id": 200,
                                "title": "Дозвон до контакт-центра составляет не более 3-4 гудков. Количество попыток дозвона не превышает 3 раз",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index4_param2"
                            },
                            {
                                "id": 300,
                                "title": "Наличие сценариев (скриптов) для операторов контакт-центра по всем услугам и сервисам СЗН (обеспечение точности информации, сценарии проходят проверку на актуальность не реже, чем 1 раз в 3 месяца (необходимо указать дату создания/пересмотра/изменения скриптов и приложить соответствующие подтверждающие документы (при наличии)))",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index4_param3"
                            },
                            {
                                "id": 400,
                                "title": "При соединении оператор первым поздоровался и представился, в т.ч. озвучил отделение ЦЗН",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index4_param4"
                            },
                            {
                                "id": 500,
                                "title": "Количество шагов для получения консультации у определенного специалиста не превышает 2 (человеку, чтобы получить необходимую консультацию, нужно пройти не более 2 переключений между различными специалистами ЦЗН)",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index4_param5"
                            }
                        ],
                        "questionType": "COMMENT",
                        "type": "CHECKLIST"
                    },
                    {
                        "id": 500,
                        "title": "Многоканальность и омниканальность взаимодействия (определяется наличие различных способов (каналов) взаимодействия с клиентом",
                        "parameters": [
                            {
                                "id": 100,
                                "title": "Форма обратной связи на региональном сайте СЗН",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index5_param1"
                            },
                            {
                                "id": 200,
                                "title": "Онлайн-чат с консультантом на региональном сайте СЗН",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index5_param2"
                            },
                            {
                                "id": 300,
                                "title": "Контакт-центр",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index5_param3"
                            },
                            {
                                "id": 400,
                                "title": "Аккаунты в социальных сетях",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index5_param4"
                            },
                            {
                                "id": 500,
                                "title": "Мессенджеры",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index5_param5"
                            },
                            {
                                "id": 600,
                                "title": "Чат-боты",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index5_param6"
                            },
                            {
                                "id": 700,
                                "title": "Книга жалоб и предложений",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index5_param7"
                            },
                            {
                                "id": 800,
                                "title": "E-mail",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index5_param8"
                            },
                            {
                                "id": 900,
                                "title": "Push-рассылка",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index5_param9"
                            },
                            {
                                "id": 1000,
                                "title": "СМС-информирование и иное (при направлении в адрес ФЦК СЗ ВНИИ труда описания канала взаимодействия, не входящего в перечень)",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index5_param10"
                            }
                        ],
                        "questionType": "COMMENT",
                        "type": "CHECKLIST"
                    },
                    {
                        "id": 600,
                        "title": "Быстрое реагирование на запрос клиента",
                        "parameters": [
                            {
                                "id": 100,
                                "title": "Наличие в ЦЗН системы анализа показателей скорости обслуживания клиентов (замеров времени ожидания в очереди, статистики контакт-центра, времени оказания услуг)",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup3_index6_param1"
                            }
                        ],
                        "questionType": "COMMENT",
                        "type": "CHECKLIST"
                    },
                    {
                        "id": 700,
                        "title": "Возможность предварительной записи на прием",
                        "parameters": [
                            {
                                "id": 100,
                                "title": "Офис ЦЗН",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index7_param1"
                            },
                            {
                                "id": 200,
                                "title": "Сайт региональной СЗН",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index7_param2"
                            },
                            {
                                "id": 300,
                                "title": "Аккаунты ЦЗН в социальных сетях",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index7_param3"
                            },
                            {
                                "id": 400,
                                "title": "Контакт-центр ЦЗН",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index7_param4"
                            }
                        ],
                        "questionType": "COMMENT",
                        "type": "CHECKLIST"
                    }
                ]
            },
            {
                "id": 400,
                "title": "Показатели внешнего комфорта и удобства",
                "indices": [
                    {
                        "id": 100,
                        "title": "Внешний вид сотрудников",
                        "parameters": [
                            {
                                "id": 100,
                                "title": "Белый верх, черный или темно-синий низ униформы (п. 5.1 Брендбука) (блуза/рубашка с длинным рукавом, юбка / брюки прямого кроя, колготки телесного цвета, если туфли – то закрытые, для мужчин допустимы только классические ботинки)",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index1_param1"
                            },
                            {
                                "id": 200,
                                "title": "Наличие платка для женщин, галстука/бабочки у мужчин, нагрудного значка с фирменным паттерном «Работа в России» (п. 5.1 Брендбука)",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index1_param2"
                            },
                            {
                                "id": 300,
                                "title": "Макияж сотрудников не должен быть слишком ярким, используемые духи не должны иметь резкий запах; волосы должны быть аккуратно подстрижены и расчесаны или убраны в хвост; руки должны быть чистыми, ногти аккуратно подстрижены (разумной длины)",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index1_param3"
                            }
                        ],
                        "questionType": "COMMENT",
                        "type": "CHECKLIST"
                    },
                    {
                        "id": 200,
                        "title": "Транспортная доступность",
                        "parameters": [
                            {
                                "id": 100,
                                "title": "Офис/точка присутствия находится в пешей доступности от остановок общественного транспорта (не более 15 минут)",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index2_param1"
                            },
                            {
                                "id": 200,
                                "title": "Наличие навигации к ЦЗН на остановках общественного транспорта/в значимых общественных местах",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index2_param2"
                            },
                            {
                                "id": 300,
                                "title": "Наличие доступной парковки на территории ЦЗН",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index2_param3"
                            },
                            {
                                "id": 400,
                                "title": "Наличие парковочных мест для инвалидов на территории ЦЗН",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index2_param4"
                            }
                        ],
                        "questionType": "COMMENT",
                        "type": "CHECKLIST"
                    },
                    {
                        "id": 300,
                        "title": "Комфортность условий для получения услуг и сервисов",
                        "parameters": [
                            {
                                "id": 100,
                                "title": "Оформление внутреннего помещения",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param1"
                            },
                            {
                                "id": 200,
                                "title": "Горизонтальная фасадная вывеска «Работа в России» размещена на фасаде",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param2"
                            },
                            {
                                "id": 300,
                                "title": "Информационная табличка (режим работы) размещена у входа в ЦЗН",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param3"
                            },
                            {
                                "id": 500,
                                "title": "Установлены скамейки",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param5"
                            },
                            {
                                "id": 600,
                                "title": "Установлены урны",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param6"
                            },
                            {
                                "id": 700,
                                "title": "Освещение фасада в соответствии с брендбуком",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param7"
                            },
                            {
                                "id": 800,
                                "title": "Уличная навигация",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param8"
                            },
                            {
                                "id": 900,
                                "title": "Информационная стелла установлена на улице",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param9"
                            },
                            {
                                "id": 1000,
                                "title": "Флаги «Работа в России» установлены снаружи здания ЦЗН",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param10"
                            },
                            {
                                "id": 1100,
                                "title": "Обустроена велопарковка",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param11"
                            },
                            {
                                "id": 1200,
                                "title": "Обустроен вход для граждан с инвалидностью",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param12"
                            },
                            {
                                "id": 1300,
                                "title": "Размещены витринные постеры",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param13"
                            },
                            {
                                "id": 1400,
                                "title": "Отделка входной группы в бренде «Работа в России»",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param14"
                            },
                            {
                                "id": 1500,
                                "title": "Стойка администратора в бренде «Работа в России»",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param15"
                            },
                            {
                                "id": 1600,
                                "title": "Доступ для граждан с инвалидностью",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param16"
                            },
                            {
                                "id": 1700,
                                "title": "Установлена электронная очередь",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param17"
                            },
                            {
                                "id": 1800,
                                "title": "Оборудован гардероб (для небольших ЦЗН – напольные вешалки)",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param18"
                            },
                            {
                                "id": 1900,
                                "title": "Оборудована мини-зона ожидания при входе (зеркало, кресла)",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param19"
                            },
                            {
                                "id": 2000,
                                "title": "Оборудована колясочная",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param20"
                            },
                            {
                                "id": 2100,
                                "title": "Компьютеры и столы размещены в цифровой зоне",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param21"
                            },
                            {
                                "id": 2200,
                                "title": "Стулья размещены в цифровой зоне",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param22"
                            },
                            {
                                "id": 2300,
                                "title": "Наличие тактильных индикаторов для граждан с инвалидностью в цифровой зоне",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param23"
                            },
                            {
                                "id": 2400,
                                "title": "Отделение цифровой зоны прозрачными перегородками",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param24"
                            },
                            {
                                "id": 2500,
                                "title": "Оформлены места для ожидания, в т.ч. для граждан с инвалидностью",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param25"
                            },
                            {
                                "id": 2600,
                                "title": "Информационные стенды установлены в зоне ожидания",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param26"
                            },
                            {
                                "id": 2700,
                                "title": "Кулер установлен в зоне ожидания",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param27"
                            },
                            {
                                "id": 2800,
                                "title": "Кондиционер установлен в зоне ожидания",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param28"
                            },
                            {
                                "id": 2900,
                                "title": "Место приема пищи, кофе-поинт установлены в зоне ожидания",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param29"
                            },
                            {
                                "id": 3000,
                                "title": "Оборудован детский уголок",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param30"
                            },
                            {
                                "id": 3100,
                                "title": "Оборудован коворкинг для клиентов",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param31"
                            },
                            {
                                "id": 3200,
                                "title": "Оборудованы переговорные для клиентов",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param32"
                            },
                            {
                                "id": 3300,
                                "title": "Оформлены окна приема клиентов",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param33"
                            },
                            {
                                "id": 3400,
                                "title": "Организовано пространство для коллективной работы / конференц-зал для клиентов",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param34"
                            },
                            {
                                "id": 3500,
                                "title": "Организована зона индивидуальной работы с гражданами",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param35"
                            },
                            {
                                "id": 3600,
                                "title": "Организована зона индивидуальной работы с гражданами с инвалидностью",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param36"
                            },
                            {
                                "id": 3700,
                                "title": "Организован конференц-зал для сотрудников (отдельный)",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param37"
                            },
                            {
                                "id": 3800,
                                "title": "Организована зона для групповых занятий и тренингов (отдельная)",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param38"
                            },
                            {
                                "id": 3900,
                                "title": "Организованы кабинеты узких специалистов",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param39"
                            },
                            {
                                "id": 4000,
                                "title": "Туалет (раздельный)",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param40"
                            },
                            {
                                "id": 4100,
                                "title": "Туалет для граждан с инвалидностью",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param41"
                            },
                            {
                                "id": 4200,
                                "title": "Комната матери и ребенка",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param42"
                            }
                        ],
                        "questionType": "COMMENT",
                        "type": "CHECKLIST"
                    }
                ]
            }
        ]
    }
}

const configv1_1 = {
    "id": 945967,
    "configParams": {
        "indexGroups": [
            {
                "id": 100,
                "title": "Показатели дружелюбия и партнерства",
                "indices": [
                    {
                        "id": 100,
                        "title": "Открытость руководства",
                        "parameters": [
                            {
                                "id": 100,
                                "title": "Проведение дней, когда руководство территориального ЦЗН «меняется» рабочими местами с сотрудниками приема",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup1_index1_param1"
                            },
                            {
                                "id": 200,
                                "title": "Наличие открытых приемных дней / часов руководства территориального ЦЗН для граждан",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup1_index1_param2"
                            },
                            {
                                "id": 300,
                                "title": "Проведение публичных мероприятий руководства территориального ЦЗН с гражданами",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup1_index1_param3"
                            },
                            {
                                "id": 400,
                                "title": "Публично доступная электронная почта руководителя территориального ЦЗН с возможностью обратиться напрямую к руководителю",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup1_index1_param4"
                            },
                            {
                                "id": 500,
                                "title": "Публично доступный номер мобильного / стационарного телефона руководителя территориального ЦЗН",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup1_index1_param5"
                            }
                        ],
                        "questionType": "COMMENT",
                        "type": "CHECKLIST"
                    }
                ]
            },
            {
                "id": 200,
                "title": "Показатели полезности обращения в СЗН",
                "indices": [
                    {
                        "id": 100,
                        "title": "Динамика роста базы вакансий",
                        "parameters": [
                            {
                                "id": 100,
                                "title": "Количество вакансий за отчетный период",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup2_index1_param1_current"
                            },
                            {
                                "id": 100,
                                "title": "Количество вакансий за отчетный период",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup2_index1_param1_previous"
                            }
                        ],
                        "questionType": "DYNAMIC",
                        "type": "CHECKLIST"
                    },
                    {
                        "id": 200,
                        "title": "Проведение мероприятий, стимулирующих рост числа соискателей",
                        "parameters": [
                            {
                                "id": 100,
                                "title": "Ярмарка вакансий",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup2_index2_param1"
                            },
                            {
                                "id": 200,
                                "title": "Подача объявлений о ЦЗН в СМИ",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup2_index2_param2"
                            },
                            {
                                "id": 300,
                                "title": "Акции в социальных сетях",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup2_index2_param3"
                            },
                            {
                                "id": 400,
                                "title": "Дни общения с руководством региональной СЗН",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup2_index2_param4"
                            },
                            {
                                "id": 500,
                                "title": "Открытый отбор на вакансии конкретного востребованного работодателя",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup2_index2_param5"
                            },
                            {
                                "id": 600,
                                "title": "Деловые игры",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup2_index2_param6"
                            },
                            {
                                "id": 700,
                                "title": "Бизнес консультации по открытию собственного дела",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup2_index2_param7"
                            },
                            {
                                "id": 800,
                                "title": "День открытых дверей в СЗН с презентацией предоставляемых услуг и сервисов",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup2_index2_param8"
                            },
                            {
                                "id": 900,
                                "title": "Экскурсии на предприятия региона",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup2_index2_param9"
                            },
                            {
                                "id": 1000,
                                "title": "И прочие мероприятия",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup2_index2_param10"
                            }
                        ],
                        "questionType": "COMMENT",
                        "type": "CHECKLIST"
                    }
                ]
            },
            {
                "id": 300,
                "title": "Показатели, характеризующие минимизацию усилий клиента",
                "indices": [
                    {
                        "id": 100,
                        "title": "Доступность и понятность информации о работе, услугах и сервисах СЗН в офисе ЦЗН",
                        "parameters": [
                            {
                                "id": 100,
                                "title": "Доступ к информационным стендам/стойкам беспрепятственный (прочесть объявления можно с близкого расстояния, стенды интуитивно легко найти / в ЦЗН есть навигация к инфостендам), в том числе для граждан с инвалидностью",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup3_index1_param1"
                            },
                            {
                                "id": 200,
                                "title": "Информация на стендах актуальна на момент оценки по показателю (проверка на предмет актуальности осуществляется не менее чем 1 раз в 3 месяца)\nПоследняя дата проверки актуальности и обновления информации - указывается дата в АИС",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup3_index1_param2"
                            },
                            {
                                "id": 300,
                                "title": "Соблюдение единого оформления стендов в корпоративном стиле (предпочтительно в соответствии с брендбуком «Работа России») в каждом документе на стенде (шрифты, цвета, фирменные элементы и пр.).",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup3_index1_param3"
                            },
                            {
                                "id": 400,
                                "title": "Информация на инфостендах удобно сгруппирована и структурирована по тематическим разделам (информация различной тематики размещена в различных информационных полях (например, объявления о работе ЦЗН и реклама находятся в разных секциях)), есть заголовки",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup3_index1_param4"
                            },
                            {
                                "id": 500,
                                "title": "Информационные тексты стенда проанализированы на сайте https://glvrd.ru",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup3_index1_param5"
                            }
                        ],
                        "questionType": "COMMENT",
                        "type": "CHECKLIST"
                    },
                    {
                        "id": 200,
                        "title": "Доступность и понятность информации о работе, услугах и сервисах СЗН на региональном сайте",
                        "parameters": [
                            {
                                "id": 100,
                                "title": "Сайт СЗН легко найти в популярных поисковиках (Яндекс, Google) (сайт находится в 3 первых позициях поисковой выдачи при введении запросов «ЦЗН региона», «центр занятости региона», «служба занятости региона»)",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index2_param1"
                            },
                            {
                                "id": 200,
                                "title": "На сайте имеется минимально необходимая информация о СЗН и ЦЗН, в т.ч. перечень и описание государственных услуг и сервисов в сфере занятости, режимы работы отделений и адреса, контактные данные СЗН и ЦЗН, ссылка на сайт «Работа в России», ссылка на сайт ОИВ, курирующих деятельность государственной службы занятости в  субъекте РФ",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index2_param2"
                            },
                            {
                                "id": 300,
                                "title": "Пользователи сайта могут найти минимально необходимую информацию интуитивно и быстро, в т.ч. с помощью навигации",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index2_param3"
                            },
                            {
                                "id": 400,
                                "title": "Сайт адаптирован для граждан с инвалидностью",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index2_param4"
                            },
                            {
                                "id": 500,
                                "title": "Информационные тексты сайта проанализированы на сайте https://glvrd.ru",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index2_param5"
                            }
                        ],
                        "questionType": "COMMENT",
                        "type": "CHECKLIST"
                    },
                    {
                        "id": 300,
                        "title": "Доступность и понятность информации о работе, услугах и сервисах СЗН в социальных сетях",
                        "parameters": [
                            {
                                "id": 100,
                                "title": "Аккаунты ЦЗН в социальных сетях открыты, не требуют подачу заявок и одобрения со стороны администраторов",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index3_param1"
                            },
                            {
                                "id": 200,
                                "title": "Комментарии к публикациям открыты/есть возможность написать сообществу, при этом ЦЗН регулярно и своевременно отвечает на комментарии пользователей",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index3_param2"
                            },
                            {
                                "id": 300,
                                "title": "Контент, в т.ч. картинки к постам, оформлен в фирменном стиле «Работа в России»",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index3_param3"
                            },
                            {
                                "id": 400,
                                "title": "В неделю размещается не менее 3 постов в одной из социальных сетей (указать, в какой)",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index3_param4"
                            },
                            {
                                "id": 500,
                                "title": "Информационные тексты аккаунта социальной сети проанализированы на сайте https://glvrd.ru",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index3_param5"
                            }
                        ],
                        "questionType": "COMMENT",
                        "type": "CHECKLIST"
                    },
                    {
                        "id": 400,
                        "title": "Доступность и понятность информации о работе, услугах и сервисах СЗН в контакт-центре",
                        "parameters": [
                            {
                                "id": 100,
                                "title": "Информация о контакт-центре доступна во всех каналах взаимодействия с гражданами (в офисе ЦЗН, на сайте, в социальных сетях), в том числе информация адаптирована для граждан с инвалидностью",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index4_param1"
                            },
                            {
                                "id": 200,
                                "title": "Дозвон до контакт-центра составляет не более 3-4 гудков. Количество попыток дозвона не превышает 3 раз. Подтверждается статистическими данными работы контакт-центра.",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index4_param2"
                            },
                            {
                                "id": 300,
                                "title": "Наличие утвержденных сценариев (скриптов) для операторов контакт-центра по всем услугам и сервисам СЗН (с указанием даты утверждения/пересмотра). Сценарии должны проходить проверку на актуальность не реже, чем 1 раз в 3 месяца.",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index4_param3"
                            },
                            {
                                "id": 400,
                                "title": "При соединении оператор первым поздоровался и представился, в т.ч. озвучил отделение ЦЗН",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index4_param4"
                            },
                            {
                                "id": 500,
                                "title": "Количество шагов для получения консультации у определенного специалиста не превышает 2 (человеку, чтобы получить необходимую консультацию, нужно пройти не более 2 переключений между различными специалистами ЦЗН)",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index4_param5"
                            }
                        ],
                        "questionType": "COMMENT",
                        "type": "CHECKLIST"
                    },
                    {
                        "id": 500,
                        "title": "Многоканальность и омниканальность взаимодействия (определяется наличие различных способов (каналов) взаимодействия с клиентом",
                        "parameters": [
                            {
                                "id": 100,
                                "title": "Форма обратной связи на региональном сайте СЗН",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index5_param1"
                            },
                            {
                                "id": 200,
                                "title": "Онлайн-чат с консультантом на региональном сайте СЗН",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index5_param2"
                            },
                            {
                                "id": 300,
                                "title": "Контакт-центр",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index5_param3"
                            },
                            {
                                "id": 400,
                                "title": "Аккаунты в социальных сетях",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index5_param4"
                            },
                            {
                                "id": 500,
                                "title": "Мессенджеры",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index5_param5"
                            },
                            {
                                "id": 600,
                                "title": "Чат-боты",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index5_param6"
                            },
                            {
                                "id": 700,
                                "title": "Книга жалоб и предложений (типовой вид для всех территориальных ЦЗН)",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index5_param7"
                            },
                            {
                                "id": 800,
                                "title": "Электронная почта региональной СЗН для группового оповещения/сбора обратной связи от клиентов",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index5_param8"
                            },
                            {
                                "id": 1000,
                                "title": "СМС-информирование и иное (при направлении в адрес ФЦК СЗ ВНИИ труда описания канала взаимодействия, не входящего в перечень)",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index5_param9"
                            },
                            {
                                "id": 1100,
                                "title": "Иное (подтверждается описанием функционирования канала взаимодействия, не входящего в перечень)",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index5_param10"
                            }
                        ],
                        "questionType": "COMMENT",
                        "type": "CHECKLIST"
                    },
                    {
                        "id": 600,
                        "title": "Быстрое реагирование на запрос клиента",
                        "parameters": [
                            {
                                "id": 100,
                                "title": "Наличие в ЦЗН системы анализа показателей скорости обслуживания клиентов (замеров времени ожидания в очереди, времени оказания услуг)",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup3_index6_param1"
                            }
                        ],
                        "questionType": "COMMENT",
                        "type": "CHECKLIST"
                    },
                    {
                        "id": 700,
                        "title": "Возможность предварительной записи на прием",
                        "parameters": [
                            {
                                "id": 100,
                                "title": "В офисе ЦЗН через киоск электронной очереди",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index7_param1"
                            },
                            {
                                "id": 200,
                                "title": "На сайте региональной СЗН через специальную форму",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index7_param2"
                            },
                            {
                                "id": 300,
                                "title": "В аккаунтах ЦЗН в социальных сетях",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index7_param3"
                            },
                            {
                                "id": 400,
                                "title": "Через контакт-центр СЗН",
                                "canUploadFile": true,
                                "onlyManagerCzn": true,
                                "parameterName": "indexGroup3_index7_param4"
                            }
                        ],
                        "questionType": "COMMENT",
                        "type": "CHECKLIST"
                    }
                ]
            },
            {
                "id": 400,
                "title": "Показатели внешнего комфорта и удобства",
                "indices": [
                    {
                        "id": 100,
                        "title": "Внешний вид сотрудников",
                        "parameters": [
                            {
                                "id": 100,
                                "title": "Белый верх, черный или темно-синий низ униформы (п. 5.1 Брендбука) (блуза/рубашка с длинным рукавом, юбка / брюки прямого кроя, колготки телесного цвета, если туфли – то закрытые, для мужчин допустимы только классические ботинки)",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index1_param1"
                            },
                            {
                                "id": 200,
                                "title": "Наличие платка для женщин, галстука/бабочки у мужчин, нагрудного значка с фирменным паттерном «Работа в России» (п. 5.1 Брендбука)",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index1_param2"
                            },
                            {
                                "id": 300,
                                "title": "Макияж сотрудников не должен быть слишком ярким, используемые духи не должны иметь резкий запах; волосы должны быть аккуратно подстрижены и расчесаны или убраны в хвост; руки должны быть чистыми, ногти аккуратно подстрижены (разумной длины)",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index1_param3"
                            }
                        ],
                        "questionType": "COMMENT",
                        "type": "CHECKLIST"
                    },
                    {
                        "id": 200,
                        "title": "Транспортная доступность",
                        "parameters": [
                            {
                                "id": 100,
                                "title": "Офис/точка присутствия находится в пешей доступности от остановок общественного транспорта (не более 15 минут)",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index2_param1"
                            },
                            {
                                "id": 200,
                                "title": "Наличие навигации к ЦЗН на остановках общественного транспорта/в значимых общественных местах",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index2_param2"
                            },
                            {
                                "id": 300,
                                "title": "Наличие доступной парковки на территории ЦЗН",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index2_param3"
                            }
                        ],
                        "questionType": "COMMENT",
                        "type": "CHECKLIST"
                    },
                    {
                        "id": 300,
                        "title": "Комфортность условий для получения услуг и сервисов",
                        "parameters": [
                            {
                                "id": 100,
                                "title": "Оформление внутреннего помещения",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param1"
                            },
                            {
                                "id": 200,
                                "title": "Горизонтальная фасадная вывеска «Работа в России» размещена на фасаде",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param2"
                            },
                            {
                                "id": 300,
                                "title": "Информационная табличка (режим работы) размещена у входа в ЦЗН",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param3"
                            },
                            {
                                "id": 500,
                                "title": "Установлены скамейки",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param5"
                            },
                            {
                                "id": 600,
                                "title": "Установлены урны",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param6"
                            },
                            {
                                "id": 700,
                                "title": "Освещение фасада в соответствии с брендбуком",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param7"
                            },
                            {
                                "id": 800,
                                "title": "Уличная навигация",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param8"
                            },
                            {
                                "id": 900,
                                "title": "Информационная стелла установлена на улице",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param9"
                            },
                            {
                                "id": 1000,
                                "title": "Флаги «Работа в России» установлены снаружи здания ЦЗН",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param10"
                            },
                            {
                                "id": 1100,
                                "title": "Обустроена велопарковка",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param11"
                            },
                            {
                                "id": 1200,
                                "title": "Обустроен вход для граждан с инвалидностью",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param12"
                            },
                            {
                                "id": 1300,
                                "title": "Размещены витринные постеры",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param13"
                            },
                            {
                                "id": 1400,
                                "title": "Отделка входной группы в бренде «Работа в России»",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param14"
                            },
                            {
                                "id": 1500,
                                "title": "Стойка администратора в бренде «Работа в России»",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param15"
                            },
                            {
                                "id": 1600,
                                "title": "Доступ для граждан с инвалидностью",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param16"
                            },
                            {
                                "id": 1700,
                                "title": "Установлена электронная очередь",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param17"
                            },
                            {
                                "id": 1800,
                                "title": "Оборудован гардероб (для небольших ЦЗН – напольные вешалки)",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param18"
                            },
                            {
                                "id": 1900,
                                "title": "Оборудована мини-зона ожидания при входе (зеркало, кресла)",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param19"
                            },
                            {
                                "id": 2000,
                                "title": "Оборудована колясочная",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param20"
                            },
                            {
                                "id": 2100,
                                "title": "Компьютеры и столы размещены в цифровой зоне",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param21"
                            },
                            {
                                "id": 2200,
                                "title": "Стулья размещены в цифровой зоне",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param22"
                            },
                            {
                                "id": 2300,
                                "title": "Наличие тактильных индикаторов для граждан с инвалидностью в цифровой зоне",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param23"
                            },
                            {
                                "id": 2400,
                                "title": "Отделение цифровой зоны прозрачными перегородками",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param24"
                            },
                            {
                                "id": 2500,
                                "title": "Оформлены места для ожидания, в т.ч. для граждан с инвалидностью",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param25"
                            },
                            {
                                "id": 2600,
                                "title": "Информационные стенды установлены в зоне ожидания",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param26"
                            },
                            {
                                "id": 2700,
                                "title": "Кулер установлен в зоне ожидания",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param27"
                            },
                            {
                                "id": 2800,
                                "title": "Кондиционер установлен в зоне ожидания",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param28"
                            },
                            {
                                "id": 2900,
                                "title": "Место приема пищи, кофе-поинт установлены в зоне ожидания",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param29"
                            },
                            {
                                "id": 3000,
                                "title": "Оборудован детский уголок",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param30"
                            },
                            {
                                "id": 3100,
                                "title": "Оборудован коворкинг для клиентов",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param31"
                            },
                            {
                                "id": 3200,
                                "title": "Оборудованы переговорные для клиентов",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param32"
                            },
                            {
                                "id": 3300,
                                "title": "Оформлены окна приема клиентов",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param33"
                            },
                            {
                                "id": 3400,
                                "title": "Организовано пространство для коллективной работы / конференц-зал для клиентов",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param34"
                            },
                            {
                                "id": 3500,
                                "title": "Организована зона индивидуальной работы с гражданами",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param35"
                            },
                            {
                                "id": 3600,
                                "title": "Организована зона индивидуальной работы с гражданами с инвалидностью",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param36"
                            },
                            {
                                "id": 3700,
                                "title": "Организован конференц-зал для сотрудников (отдельный)",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param37"
                            },
                            {
                                "id": 3800,
                                "title": "Организована зона для групповых занятий и тренингов (отдельная)",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param38"
                            },
                            {
                                "id": 3900,
                                "title": "Организованы кабинеты узких специалистов",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param39"
                            },
                            {
                                "id": 4000,
                                "title": "Туалет (раздельный)",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param40"
                            },
                            {
                                "id": 4100,
                                "title": "Туалет для граждан с инвалидностью",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param41"
                            },
                            {
                                "id": 4200,
                                "title": "Комната матери и ребенка",
                                "canUploadFile": true,
                                "onlyManagerCzn": false,
                                "parameterName": "indexGroup4_index3_param42"
                            }
                        ],
                        "questionType": "COMMENT",
                        "type": "CHECKLIST"
                    }
                ]
            }
        ]
    }
}









const config_v2 = {"groups": [{"title": "Показатели дружелюбия и партнерства", "groups": [{"title": "Открытость руководства", "questions": [{"id": "04f1630e-3b2f-4b52-bb82-24156d927484", "title": "Проведение дней, когда руководство территориального ЦЗН «меняется» рабочими местами с сотрудниками приема", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "0d479d02-47c5-415f-bbfd-11bd92534e3d", "title": "Наличие открытых приемных дней / часов руководства территориального ЦЗН для граждан и работодателей", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "0e9b9e75-484b-4e28-bc1a-a085432e5aa8", "title": "Проведение публичных мероприятий руководства территориального ЦЗН с гражданами и работодателями", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "0fcc8554-5b08-4d89-8bd6-929ca1a5087e", "title": "Публично доступная электронная почта руководителя территориального ЦЗН", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "0fdbaf70-6b8d-4cf9-942e-65a84c985a6e", "title": "Публично доступный номер мобильного / стационарного телефона руководителя территориального ЦЗН", "type": "COMMENT", "onlyManagerCzn": false}]}]}, {"title": "Показатели полезности обращения в СЗН", "groups": [{"title": "Динамика роста базы вакансий", "questions": [{"id": "16be875b-104e-42cb-9f5a-70e833ee6f12", "title": "Количество вакансий за отчетный период", "type": "DYNAMIC", "onlyManagerCzn": false}]}, {"title": "Проведение мероприятий, стимулирующих рост числа граждан", "questions": [{"id": "1867180f-0be8-4351-85f8-41e2a935b490", "title": "Ярмарка вакансий", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "1929244d-5eaf-4db5-9fc8-2cbbadcfea16", "title": "Подача объявлений о территориальном ЦЗН в средствах массовой информации", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "1aa7cd19-8444-4e67-bc25-e886d2acdd63", "title": "Акции в социальных сетях", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "1b191748-ac16-4a8a-86e8-76cc881a04f5", "title": "Дни общения с руководством государственного учреждения службы занятости", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "1bd3dd54-5f22-4783-8293-ca3715525f77", "title": "Открытый отбор на вакансии конкретного востребованного работодателя", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "215afdd6-618e-45b7-8313-49a7104dc93e", "title": "Деловые игры", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "28b53d86-321f-4fcf-8f0b-5b10af768a65", "title": "Бизнес консультации по открытию собственного дела", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "2b916070-8c8b-4fe3-b0d5-712c8c615dc2", "title": "День открытых дверей в государственном учреждении службы занятости с презентацией предоставляемых услуг и сервисов", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "327adccf-b7b4-4279-8acb-8dc2508246da", "title": "Экскурсии на предприятия региона", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "3d071c1a-b655-4a31-9e7d-08a46265ec7b", "title": "И прочие мероприятия", "type": "COMMENT", "onlyManagerCzn": false}]}]}, {"title": "Показатели, характеризующие минимизацию усилий клиента", "groups": [{"title": "Доступность и понятность информации о работе, услугах и сервисах государственного учреждения службы занятости в офисе территориального ЦЗН", "questions": [{"id": "3dbd6fd1-d854-4563-8c2b-32655f867f77", "title": "Доступ к информационным стендам/стойкам беспрепятственный (прочесть объявления можно с близкого расстояния, стенды интуитивно легко найти / в территориальном ЦЗН есть навигация к информационным стендам), в том числе для граждан с инвалидностью", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "44a890b3-d0eb-42a1-b322-83b181dc4f3a", "title": "Информация на стендах актуальна на момент оценки по показателю (проверка на предмет актуальности осуществляется не менее чем 1 раз в 3 месяца)\nПоследняя дата проверки актуальности и обновления информации - указывается дата в АИС", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "45be40c3-340d-4ae3-beff-02f3214ebb4d", "title": "Соблюдение единого оформления информационных стендов в соответствии с Брендбуком «Работа России», в каждом документе на стенде (шрифты, цвета, фирменные элементы и пр.).", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "45e6acda-fbde-4362-ba58-6e1f484a44bc", "title": "Информация на стендах удобно сгруппирована и структурирована по тематическим разделам (информация различной тематики размещена в различных информационных полях (например, объявления о деятельности территориального ЦЗН и реклама находятся в разных секциях)), есть заголовки", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "48273ff9-8eed-472d-90f7-8601e8bb0640", "title": "Информационные тексты проанализированы на сайте https://glvrd.ru", "type": "COMMENT", "onlyManagerCzn": false}]}, {"title": "Доступность и понятность информации о работе, услугах и сервисах государственного учреждения службы занятости на сайте государственного учреждения службы занятости", "questions": [{"id": "48505c1d-455b-4afd-8e6d-e9a659eb3fb8", "title": "Сайт государственного учреждения службы занятости легко найти в популярных поисковиках (Яндекс, Google) (сайт находится в 3 первых позициях поисковой выдачи при введении запросов «ЦЗН региона», «центр занятости региона», «служба занятости региона»)", "type": "COMMENT", "onlyManagerCzn": true}, {"id": "4bbc9d90-259b-4df3-a7aa-fc63e1e7ee71", "title": "На сайте имеется минимально необходимая информация о государственном учреждении службы занятости и территориальных ЦЗН, в т.ч. перечень и описание государственных услуг и сервисов в сфере занятости населения, режимы работы территориальных ЦЗН и адреса, контактные данные государственного учреждения службы занятости, территориальных ЦЗН, ссылка на сайт «Работа России», на сайт исполнительного органа субъекта Российской Федерации, осуществляющего полномочия в сфере занятости населения", "type": "COMMENT", "onlyManagerCzn": true}, {"id": "4c7fb1f6-a5a9-41b9-8495-3c9dabc39f9b", "title": "Пользователи сайта могут найти минимально необходимую информацию интуитивно и быстро, в т.ч. с помощью навигации", "type": "COMMENT", "onlyManagerCzn": true}, {"id": "5393a1c8-54c5-41cd-9eb9-49a261813864", "title": "Сайт адаптирован для граждан с инвалидностью", "type": "COMMENT", "onlyManagerCzn": true}, {"id": "5aaf7fb7-c6bc-4370-a41a-9efe9f422f05", "title": "Информационные тексты размещенные на сайте проанализированы на сайте https://glvrd.ru", "type": "COMMENT", "onlyManagerCzn": true}]}, {"title": "Доступность и понятность информации о работе, услугах и сервисах государственного учреждения службы занятости в социальных сетях", "questions": [{"id": "60814632-7d2e-4ed8-87f1-af46449233cc", "title": "Аккаунты государственного учреждения службы занятости в социальных сетях открыты, не требуют подачу заявок и одобрения со стороны администраторов", "type": "COMMENT", "onlyManagerCzn": true}, {"id": "619278fd-110e-40fa-ac8e-19d88ef1db2f", "title": "Комментарии к публикациям открыты/есть возможность написать сообществу, при этом государственное учреждение службы занятости регулярно и своевременно отвечает на комментарии клиентов", "type": "COMMENT", "onlyManagerCzn": true}, {"id": "6260a543-079d-4af0-a954-79794e143a6c", "title": "Контент, в т.ч. картинки к постам, оформлен в соответствии с Брендбуком «Работа России»", "type": "COMMENT", "onlyManagerCzn": true}, {"id": "63c40bdc-636e-4498-8d8d-133d09c6347a", "title": "В неделю размещается не менее 3 постов в одной из социальных сетей (указать, в какой)", "type": "COMMENT", "onlyManagerCzn": true}, {"id": "6e156165-82d1-44de-90fe-01cec5713716", "title": "Информационные тексты проанализированы на сайте https://glvrd.ru", "type": "COMMENT", "onlyManagerCzn": true}]}, {"title": "Доступность и понятность информации о работе, услугах и сервисах государственного учреждения службы занятости в контакт-центре", "questions": [{"id": "6f9c38d7-904d-4d72-b859-1c26556fb10c", "title": "Информация о контакт-центре доступна во всех каналах взаимодействия с гражданами (в помещении территориального ЦЗН, на сайте, в социальных сетях), в том числе информация адаптирована для граждан с инвалидностью", "type": "COMMENT", "onlyManagerCzn": true}, {"id": "6fa9db94-7e62-4902-822c-85abd34365d7", "title": "Дозвон до контакт-центра составляет не более 3-4 гудков. Количество попыток дозвона не превышает 3 раз.", "type": "COMMENT", "onlyManagerCzn": true}, {"id": "709a76b6-caf3-4dd3-a0d9-59c5396a33cd", "title": "Наличие утвержденных государственным учреждением службы занятости сценариев (скриптов)(далее - скрипты) для операторов контакт-центра по всем услугам и сервисам государственного учреждения службы занятости (с указанием даты утверждения/пересмотра). Сценарии должны проходить проверку на актуальность не реже, чем 1 раз в 3 месяца", "type": "COMMENT", "onlyManagerCzn": true}, {"id": "74828961-870a-440c-ad5a-fb3bc9c2e5b0", "title": "При соединении оператор первым поздоровался и представился, в т.ч. озвучил территориальный ЦЗН", "type": "COMMENT", "onlyManagerCzn": true}, {"id": "7514f31e-fcda-4426-9159-41a8cb61197c", "title": "Количество шагов для получения консультации у определенного специалиста не превышает 2 (звонящему, чтобы получить необходимую консультацию, нужно пройти не более 2 переключений между различными специалистами государственного учреждения службы занятости)", "type": "COMMENT", "onlyManagerCzn": true}]}, {"title": "Многоканальность и омниканальность взаимодействия", "questions": [{"id": "757f8bec-68bf-4bc9-abce-738b42434256", "title": "Форма обратной связи на сайте государственного учреждения службы занятости", "type": "COMMENT", "onlyManagerCzn": true}, {"id": "7db92ffc-54e9-409d-94cf-a76725443a17", "title": "Онлайн-чат с консультантом на сайте государственного учреждения службы занятости", "type": "COMMENT", "onlyManagerCzn": true}, {"id": "7fdb4bb3-3a2a-465f-be95-77b3b54dabb8", "title": "Контакт-центр", "type": "COMMENT", "onlyManagerCzn": true}, {"id": "81b0b03a-929b-4f35-b70b-16715f8522a4", "title": "Аккаунты в социальных сетях", "type": "COMMENT", "onlyManagerCzn": true}, {"id": "837a44d3-11dd-411f-a365-ba1d66fcf6d1", "title": "Мессенджеры", "type": "COMMENT", "onlyManagerCzn": true}, {"id": "84135237-b1eb-41f8-84a3-497466f6312a", "title": "Чат-боты", "type": "COMMENT", "onlyManagerCzn": true}, {"id": "86558f71-c426-4314-aa77-42a1d8151f67", "title": "Книга жалоб и предложений (образец для всех территориальных ЦЗН утверждается руководителем государственного учреждения службы занятости)", "type": "COMMENT", "onlyManagerCzn": true}, {"id": "870e9671-bd4e-4f96-93a5-26a2c7509d6a", "title": "Электронная почта государственного учреждения службы занятости для группового оповещения/сбора обратной связи от клиентов", "type": "COMMENT", "onlyManagerCzn": true}, {"id": "8af4ab88-f640-42b5-9fa6-048edd2495ca", "title": "СМС-информирование для группового оповещения/сбора обратной связи от клиентов", "type": "COMMENT", "onlyManagerCzn": true}, {"id": "8b0d6d32-7c7b-4fbe-b22f-0fa66f6787eb", "title": "Иные каналы", "type": "COMMENT", "onlyManagerCzn": true}]}, {"title": "Быстрое реагирование на запрос клиента", "questions": [{"id": "8d912c37-f337-46fe-a7e5-fc7576002cb4", "title": "Наличие в территориальном ЦЗН системы анализа показателей скорости обслуживания клиентов (замеров времени ожидания в очереди, времени оказания услуг и т.д.)", "type": "COMMENT", "onlyManagerCzn": false}]}, {"title": "Возможность предварительной записи на прием", "questions": [{"id": "90fcff23-7a85-4e2d-b878-db0f8bd1e9a6", "title": "В офисе территориальных ЦЗН через электронную очередь", "type": "COMMENT", "onlyManagerCzn": true}, {"id": "9146039e-0a51-427c-9fd6-e17e6070e90c", "title": "На сайте государственного учреждения службы занятости через специальную форму", "type": "COMMENT", "onlyManagerCzn": true}, {"id": "9b20f47d-b91d-4ee3-a23c-c7397a1d960b", "title": "В аккаунтах государственного учреждения службы занятости в социальных сетях", "type": "COMMENT", "onlyManagerCzn": true}, {"id": "a264850a-433a-43df-bd9d-e9e1dbc62fda", "title": "Через контакт-центр государственного учреждения службы занятости", "type": "COMMENT", "onlyManagerCzn": true}]}]}, {"title": "Показатели внешнего комфорта и удобства", "groups": [{"title": "Внешний вид сотрудников", "questions": [{"id": "a3b2adba-89ac-4b5b-9fc0-1f9af09938b5", "title": "Белый верх, черный или темно-синий низ униформы (п. 5.1 Брендбука «Работа России») (блуза/рубашка с длинным рукавом, юбка / брюки прямого кроя, колготки телесного цвета, если туфли – то закрытые, для мужчин допустимы только классические ботинки)", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "a491906f-9ee7-46a2-bc68-5e23fa0d1552", "title": "Наличие платка для женщин, галстука/бабочки у мужчин, нагрудного значка с фирменным паттерном «Работа России» (п. 5.1 Брендбука «Работа России»)", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "a6357927-89d9-4f70-bb16-feb82db85971", "title": "Макияж сотрудников не должен быть слишком ярким, используемые духи не должны иметь резкий запах; волосы должны быть аккуратно подстрижены и расчесаны или убраны в хвост; руки должны быть чистыми, ногти аккуратно подстрижены (разумной длины)", "type": "COMMENT", "onlyManagerCzn": false}]}, {"title": "Транспортная доступность", "questions": [{"id": "a64b9ecd-005d-4054-9c84-634c50d6cac3", "title": "Помещение территориального ЦЗН находится в пешей доступности от остановок общественного транспорта (не более 15 минут)", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "a9d2e7c9-5cca-4010-a8ef-8de467fa8f1b", "title": "Наличие навигации к территориальному ЦЗН на остановках общественного транспорта/ в значимых общественных местах", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "ab5e300b-4ba3-435e-a2a0-5131fbd8fac9", "title": "Наличие доступной парковки около территориального ЦЗН", "type": "COMMENT", "onlyManagerCzn": false}]}, {"title": "Комфортность условий для получения услуг и сервисов", "groups": [{"title": "Доступная среда", "questions": [{"id": "abd70aae-4724-49ba-8ba5-8e708f004af2", "title": "Наличие парковочных мест для инвалидов у территориального ЦЗН", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "b0e35aae-e3d1-4812-b2a6-f614536a7e80", "title": "Оборудованный вход для инвалидов (пандусы, кнопка вызова сотрудника, наклейки на входной двери и т.д.)", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "b21773ae-6af4-49b2-8760-93418b65a0c7", "title": "Оснащение внутреннего помещения территориального ЦЗН (указатели со шрифтами Брайля, тактильные индикаторы, тактильная плитка и т.д.)", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "b3c5f2eb-6826-4f3d-a613-e492235b3342", "title": "Туалет для граждан с инвалидностью", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "b3e9d941-d874-4c09-bb49-8f66cc95cf16", "title": "Зона индивидуальной работы с гражданами с инвалидностью, в т.ч. оснащение места специальным оборудованием для граждан с инвалидностью", "type": "COMMENT", "onlyManagerCzn": false}]}, {"title": "ЦЗН 3-го уровня", "groups": [{"title": "Оформление экстерьера", "questions": [{"id": "b470ae23-3939-40a9-ada3-97061435e469", "title": "Горизонтальная фасадная вывеска «Работа России»", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "b4c7f3ec-8647-40ae-b990-d7a1675ebec2", "title": "Информационная табличка (режим работы)", "type": "COMMENT", "onlyManagerCzn": false}]}, {"title": "Оформление входной группы", "questions": [{"id": "b72fba1d-0b6a-4152-b3a1-5cae4d13886f", "title": "Отделка входной группы в соответствии с Брендбуком «Работа России»", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "b87d3e98-f8a8-4909-a539-8bdde7744438", "title": "Стойка администратора", "type": "COMMENT", "onlyManagerCzn": false}]}, {"title": "Оформление цифровой зоны", "questions": [{"id": "b8e37591-8293-47ee-96a2-09ad0389c100", "title": "Компьютеры,столы, стулья", "type": "COMMENT", "onlyManagerCzn": false}]}, {"title": "Оформление зоны ожидания", "questions": [{"id": "ba02e66f-2a0f-4f5a-b716-824150bcd7f0", "title": "Места для ожидания", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "ba0bfcb7-eaa4-4306-b63c-6d4b84d5883f", "title": "Информационные стенды", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "ba79375e-e516-4ed8-99dc-4ef018c1009f", "title": "Кулер", "type": "COMMENT", "onlyManagerCzn": false}]}], "questions": [{"id": "bfaaa110-9167-431a-ae12-a0feb98acc78", "title": "Окна приема клиентов", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "c036ca31-8d90-484e-9821-9e87df442767", "title": "Туалет (раздельный)", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "c1b7654e-f468-4a52-ad93-67784cc2a40d", "title": "Наличие дополнительных сервисов", "type": "COMMENT", "onlyManagerCzn": false}], "onlyCznType": 3}, {"title": "ЦЗН 2-го уровня", "groups": [{"title": "Оформление экстерьера", "questions": [{"id": "b470ae23-3939-40a9-ada3-97061435e469", "title": "Горизонтальная фасадная вывеска «Работа России»", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "b4c7f3ec-8647-40ae-b990-d7a1675ebec2", "title": "Информационная табличка (режим работы)", "type": "COMMENT", "onlyManagerCzn": false}]}, {"title": "Оформление входной группы", "questions": [{"id": "b72fba1d-0b6a-4152-b3a1-5cae4d13886f", "title": "Отделка входной группы в соответствии с Брендбуком «Работа России»", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "b87d3e98-f8a8-4909-a539-8bdde7744438", "title": "Стойка администратора", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "203fd85a-3bd0-4936-95db-3073336a2a2f", "title": "Электронная очередь", "type": "COMMENT", "onlyManagerCzn": false}]}, {"title": "Оформление цифровой зоны", "questions": [{"id": "b8e37591-8293-47ee-96a2-09ad0389c100", "title": "Компьютеры,столы, стулья", "type": "COMMENT", "onlyManagerCzn": false}]}, {"title": "Оформление зоны ожидания", "questions": [{"id": "ba02e66f-2a0f-4f5a-b716-824150bcd7f0", "title": "Места для ожидания", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "ba0bfcb7-eaa4-4306-b63c-6d4b84d5883f", "title": "Информационные стенды", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "ba79375e-e516-4ed8-99dc-4ef018c1009f", "title": "Кулер", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "42bbb87b-9ab1-4105-b4a9-2372ed6030d5", "title": "Кондиционер", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "43df209c-1d87-4642-afe1-dd79f0e0442a", "title": "Место приема пищи для клиентов/кофе-поинт", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "43f1e209-dc50-4524-b87a-7d4b53265492", "title": "Детский уголок", "type": "COMMENT", "onlyManagerCzn": false}]}], "questions": [{"id": "bfaaa110-9167-431a-ae12-a0feb98acc78", "title": "Окна приема клиентов", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "f13d5782-48c7-4f27-b767-3c5b9d240700", "title": "Пространство для коллективной работы/конференц-зал", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "f2a9cdce-cbea-4274-91b9-86cbb6a2d3b8", "title": "Зона индивидуальной работы с гражданами/работодателями", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "c036ca31-8d90-484e-9821-9e87df442767", "title": "Туалет (раздельный)", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "c1b7654e-f468-4a52-ad93-67784cc2a40d", "title": "Наличие дополнительных сервисов", "type": "COMMENT", "onlyManagerCzn": false}], "onlyCznType": 2}, {"title": "ЦЗН 1-го уровня", "groups": [{"title": "Оформление экстерьера", "questions": [{"id": "b470ae23-3939-40a9-ada3-97061435e469", "title": "Горизонтальная фасадная вывеска «Работа России»", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "b4c7f3ec-8647-40ae-b990-d7a1675ebec2", "title": "Информационная табличка (режим работы)", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "02c33cdc-9a3d-4f8e-9782-4c16943cb396", "title": "Скамейки", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "04c3858d-7f9e-47dd-9cac-63e16c0588a2", "title": "Урны", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "0541ec62-52e7-40cf-b403-c6b102a1b845", "title": "Освещение (в соответствии с брендбуком)", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "0ed889bd-b7cf-43b5-a144-5c36d870b389", "title": "Уличная навигация", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "0f849618-c226-491c-84e3-5abfe9ec348c", "title": "Информационная стела", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "0ffd2058-b4c3-4f3c-aa6a-88e7f318c150", "title": "Флаги «Работа России»", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "1034c16d-cfb5-4464-bed5-22d86f20b6d0", "title": "Велопарковка", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "18344ee1-78d9-4728-84d8-de684cf682df", "title": "Витринные постеры", "type": "COMMENT", "onlyManagerCzn": false}]}, {"title": "Оформление входной группы", "questions": [{"id": "b72fba1d-0b6a-4152-b3a1-5cae4d13886f", "title": "Отделка входной группы в соответствии с Брендбуком «Работа России»", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "b87d3e98-f8a8-4909-a539-8bdde7744438", "title": "Стойка администратора", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "203fd85a-3bd0-4936-95db-3073336a2a2f", "title": "Электронная очередь", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "2bc66574-717b-481d-96ee-ba0af07dcb52", "title": "Гардероб (для небольших территориальных ЦЗН – напольные вешалки)", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "3879a806-cff7-4ab4-ab4c-344c4986795d", "title": "Мини-зона ожидания при входе (зеркало, кресла)", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "3a510e36-01f2-438b-bf0c-c8cbfe596803", "title": "Колясочная", "type": "COMMENT", "onlyManagerCzn": false}]}, {"title": "Оформление цифровой зоны", "questions": [{"id": "b8e37591-8293-47ee-96a2-09ad0389c100", "title": "Компьютеры, столы, стулья", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "3f601efb-c4e7-4e2b-ae50-e913617e091d", "title": "Отделение цифровой зоны прозрачными перегородками", "type": "COMMENT", "onlyManagerCzn": false}]}, {"title": "Оформление зоны ожидания", "questions": [{"id": "ba02e66f-2a0f-4f5a-b716-824150bcd7f0", "title": "Места для ожидания", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "ba0bfcb7-eaa4-4306-b63c-6d4b84d5883f", "title": "Информационные стенды", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "ba79375e-e516-4ed8-99dc-4ef018c1009f", "title": "Кулер", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "42bbb87b-9ab1-4105-b4a9-2372ed6030d5", "title": "Кондиционер", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "43df209c-1d87-4642-afe1-dd79f0e0442a", "title": "Место приема пищи для клиентов/кофе-поинт", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "43f1e209-dc50-4524-b87a-7d4b53265492", "title": "Детский уголок", "type": "COMMENT", "onlyManagerCzn": false}]}], "questions": [{"id": "bfaaa110-9167-431a-ae12-a0feb98acc78", "title": "Окна приема клиентов", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "f13d5782-48c7-4f27-b767-3c5b9d240700", "title": "Пространство для коллективной работы/конференц-зал", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "f2a9cdce-cbea-4274-91b9-86cbb6a2d3b8", "title": "Зона индивидуальной работы с гражданами/ работодателями", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "5bbba93c-3934-4957-a5e6-57a57df87204", "title": "Коворкинг", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "601d88df-4bfd-4e96-b64a-9c18a8fa2120", "title": "Переговорные", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "60bac2a9-0a81-4f1f-a319-a2266b118ac8", "title": "Конференц-зал для сотрудников (отдельный)", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "671f7546-1da2-435e-b7b2-445dfadff28c", "title": "Зона для групповых занятий и тренингов (отдельный)", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "71c5f4c7-cebd-4cff-bbdd-3b29faccfc7b", "title": "Кабинеты узких специалистов", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "733df785-083e-4865-9ba9-2531abc46acd", "title": "Комната матери и ребенка", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "c036ca31-8d90-484e-9821-9e87df442767", "title": "Туалет (раздельный)", "type": "COMMENT", "onlyManagerCzn": false}, {"id": "c1b7654e-f468-4a52-ad93-67784cc2a40d", "title": "Наличие дополнительных сервисов", "type": "COMMENT", "onlyManagerCzn": false}], "onlyCznType": 1}]}]}]}
